export const firebaseConfig = {
  apiKey: "AIzaSyAVSxcU3H0AxdaNed1lfPKORATu-emwORQ",
  authDomain: "axelone-global.firebaseapp.com",
  projectId: "axelone-global",
  storageBucket: "axelone-global.firebasestorage.app",
  messagingSenderId: "365000939982",
  appId: "1:365000939982:web:e54d43781200df6c0a339f",
  measurementId: "G-9M498DJPF4"
};